export default "__VITE_ASSET__CrJ50_xZ__"